const { Schema, models, model } = require('mongoose');

const Code = new Schema({
    position: { type: Number },
    name: {},
    status: { type: Boolean },
    text: {}
});
module.exports = models?.codes || model('codes', Code);
